import React from 'react';
import { Row, Col, Button } from 'antd';
import Tag from '../Tag';
import { TagTypes } from '../../types';
import EllipsisSteps from '../EllipsisSteps';
import get from 'lodash/get';
import moment from 'moment';
import IconLeft from '../Icons/IconLeft';
import IconRight from '../Icons/IconRight';
import { useWindowSize } from '../../hooks/useWindowSize';
import './CalendarPeriod.less';

export type CalendarPeriodProps = {
  period: number;
  periodCount: number;
  changPeriod: any;
  sessions: any;
  periodStatistics: {
    attend: number;
    absent: number;
    attendancePerformance: number;
  };
  onClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const CalendarPeriod: React.FC<CalendarPeriodProps> = ({
  periodStatistics,
  period,
  periodCount,
  changPeriod,
  sessions,
  ...props
}) => {
  const size = useWindowSize();
  const isDesktop = size.width < 1025;
  const isMobile = size.width < 426;

  const leftArrowColProps = {
    xs: isDesktop ? 24 : 1,
    sm: isDesktop ? 24 : 1,
    md: isDesktop ? 24 : 1,
    lg: isDesktop ? 24 : 1,
    xl: 1,
    xxl: 1,
  };

  const ellipsisColProps = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 17,
    xxl: 19,
  };

  const rightArrowColProps = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: isDesktop ? 24 : 4,
    xl: 5,
    xxl: 4,
  };

  return (
    <Row
      gutter={24}
      align="middle"
      justify="space-between"
      className="period-container"
    >
      <Col
        {...leftArrowColProps}
        className={isDesktop ? 'center mr-bottom' : ''}
      >
        <Button
          className="arrow-icon"
          icon={<IconLeft size="md" fill="none" />}
          disabled={!(periodCount > 1 && period !== 1)}
          onClick={() => changPeriod(period - 1)}
        />
        {isDesktop && (
          <Button
            className="arrow-icon"
            icon={<IconRight size="md" fill="none" />}
            disabled={!(periodCount > 1 && period !== periodCount)}
            onClick={() => changPeriod(period + 1)}
          />
        )}
      </Col>

      <Col {...ellipsisColProps}>
        <Row
          gutter={24}
          align="middle"
          justify="space-between"
          className={isDesktop ? 'mr-bottom' : ''}
        >
          <EllipsisSteps
            renderTitle={(value) =>
              value.period
                ? `${moment(value.startDate).format('MMM-DD')} - ${moment(
                    value.endDate,
                  ).format('MMM-DD')}`
                : ''
            }
            handelNext={(step) => {
              changPeriod(step);
            }}
            currentStep={period - 1}
            steps={get(sessions, 'periods', [])}
          />
        </Row>
      </Col>

      <Col {...rightArrowColProps}>
        <Row gutter={24} align="middle" justify={isDesktop ? 'center' : 'end'}>
          <Col>
            <Tag type={TagTypes.TRIAL}>{periodStatistics.attend || 0}</Tag>
          </Col>
          <Col>
            <Tag type={TagTypes.WRONG}>{periodStatistics.absent || 0}</Tag>
          </Col>
          <Col>
            <Tag
              type={
                periodStatistics.attendancePerformance < 50
                  ? TagTypes.WRONG
                  : TagTypes.TRIAL
              }
            >
              {get(periodStatistics, 'attendancePerformance', 0)}
            </Tag>
          </Col>
          {!isDesktop && (
            <Button
              className="arrow-icon"
              icon={<IconRight size="md" fill="none" />}
              disabled={!(periodCount > 1 && period !== periodCount)}
              onClick={() => changPeriod(period + 1)}
            />
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default CalendarPeriod;
